import axios from "../../config/axiosConfig";

export default {
	get: () => axios.get(`/get/customers`),
	add: (data) => axios.post(`/add/customers`, data),
	update: (data) => axios.post(`/update/customers`, data),
	remove: (data) => axios.post(`/disabled/customers`, data),
};
